import React, { useRef, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function Home() {
	const [mouseData, setMouseData] = useState({ x: 0, y: 0 });
	const canvasRef = useRef(null);
	const [canvasCTX, setCanvasCTX] = useState(null);
	const [color, setColor] = useState('#333333');
	const [size, setSize] = useState(3);
	const [squareColor1, setSquareColor1] = useState('#8ea0aa');
	const [squareColor2, setSquareColor2] = useState('#9ef6aa');
 
	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
		setCanvasCTX(ctx);
	}, [canvasRef]);

	// Helper function to convert hex to HSL
	const hexToHsl = (hex) => {
		const r = parseInt(hex.slice(1, 3), 16) / 255;
		const g = parseInt(hex.slice(3, 5), 16) / 255;
		const b = parseInt(hex.slice(5, 7), 16) / 255;

		const max = Math.max(r, g, b);
		const min = Math.min(r, g, b);
		let h, s, l = (max + min) / 2;

		if (max === min) {
			h = s = 0; // achromatic
		} else {
			const d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
			switch (max) {
				case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
				case g: h = ((b - r) / d + 2) / 6; break;
				case b: h = ((r - g) / d + 4) / 6; break;
				default: h = 0;
			}
		}
		return { h: h * 360, s: s * 100, l: l * 100 };
	};

	// Calculate square colors based on clock: first square = hours, second square = minutes
	useEffect(() => {
		// Get starting hues from initial colors
		const startColor1 = hexToHsl('#8ea0aa');
		const startColor2 = hexToHsl('#9ef6aa');
		const startHue1 = startColor1.h;
		const startHue2 = startColor2.h;

		const calculateSquareColors = () => {
			const now = new Date();
			// First square: based on hours (0-23)
			const hours = now.getHours();
			// Calculate progress through 24-hour cycle (0 to 1)
			const hourProgress = hours / 24;
			// Calculate hue by adding progress * 360 to starting hue
			const hue1 = (startHue1 + hourProgress * 360) % 360;
			
			// Second square: based on minutes (0-59)
			const minutes = now.getMinutes();
			// Calculate progress through 60-minute cycle (0 to 1)
			const minuteProgress = minutes / 60;
			// Calculate hue by adding progress * 360 to starting hue
			const hue2 = (startHue2 + minuteProgress * 360) % 360;
			
			// Use HSL with fixed saturation and lightness for vibrant colors
			const saturation = 50;
			const lightness = 65;
			const hslColor1 = `hsl(${hue1}, ${saturation}%, ${lightness}%)`;
			const hslColor2 = `hsl(${hue2}, ${saturation}%, ${lightness}%)`;
			setSquareColor1(hslColor1);
			setSquareColor2(hslColor2);
		};

		// Calculate initial colors
		calculateSquareColors();

		// Update colors every minute (minute square changes every minute, hour square changes every hour)
		const interval = setInterval(calculateSquareColors, 60000);

		return () => clearInterval(interval);
	}, []);
 
	const SetPos = (e) => {

    // const ctx = canvasCTX;
    // ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    
		setMouseData({
			x: e.clientX,
			y: e.clientY
		});
    Draw(e);
	};
 
	const Draw = (e) => {
		//if (e.buttons !== 1) return;
		const ctx = canvasCTX;
		ctx.beginPath();
		ctx.moveTo(mouseData.x, mouseData.y);
		setMouseData({
			x: e.clientX,
			y: e.clientY
		});
		ctx.lineTo(e.clientX, e.clientY);
		ctx.strokeStyle = color;
		ctx.lineWidth = size;
		// Set the line cap to round
		ctx.lineCap = 'round';
		ctx.stroke();
	};

  return (
    <>
      <div
        style={{
          mixBlendMode: "multiply",
          display: "block",
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999,
          pointerEvents: 'none',          
        }} 
      >
        <canvas
          ref={canvasRef}
          onMouseEnter={(e) => SetPos(e)}
          onMouseDown={(e) => SetPos(e)}
          onMouseMove={(e) => Draw(e)}
        ></canvas>
      </div>
      
      <Container fluid 
        className="home-section" id="home" 
        onMouseEnter={(e) => SetPos(e)}
        onMouseDown={(e) => SetPos(e)}
        onMouseMove={(e) => Draw(e)}
      >
      <header>
        <nav>
          <ul>
            <li className="active-page">(Here)</li>
            <li><Link to="/project">Projects</Link></li>
            {/* <li><Link to="/about">About</Link></li> */}
          </ul>
        </nav>
      </header>        
        <Container className="home-content">
          <div className="square-text-container">
            <div className="square-wrapper">
              {/* Square element - can be made invisible with CSS */}
              <div className="square-box" style={{ backgroundColor: squareColor1 }}></div>
              
              {/* Top edge text - horizontal, left to right */}
              <div className="square-text square-text-top">
                <Link to="/project">SELECT PROJECTS</Link>
              </div>
              
              {/* Right edge text - vertical, top to bottom */}
              <div className="square-text square-text-right">
                <Link to="/about">ABOUT</Link>
              </div>
              
              {/* Bottom edge text - horizontal, rotated 180° */}
              <div className="square-text square-text-bottom">
                <a href="https://wrfg.org/show/ambient/" target="_blank" rel="noreferrer noopener">MISC</a>
              </div>
              
              {/* Left edge text - vertical, bottom to top */}
              <div className="square-text square-text-left">
                <Link to="/contact">CONTACT</Link>
              </div>

            </div>
            
            {/* Second square for additional text */}
            <div className="square-wrapper square-wrapper-second">
              <div className="square-box" style={{ backgroundColor: squareColor2 }}></div>
              
              {/* Top edge text - horizontal, left to right */}
              <div className="square-text square-text-top">
                somewhat slowly
              </div>

              {/* Right edge text - vertical, top to bottom */}
              <div className="square-text square-text-right">
                <Link to="/clock">these colors are changing</Link>
              </div>
              
              {/* Bottom edge text - horizontal, rotated 180° */}
              <div className="square-text square-text-bottom">
                somewhat slowly
              </div>
              
              {/* Left edge text - vertical, bottom to top */}
              <div className="square-text square-text-left">
                these colors have changed
              </div>
            </div>
          </div>
        </Container>
      </Container>
    </>
  );
}

export default Home;